import React from 'react'
import classNames from 'classnames'

export const SimpleSpinner = ({ spinnerClass }) => (
  <div className={classNames('center-xs', spinnerClass)}>
    <i className="spinner spinner-md primary" />
  </div>
)

export default SimpleSpinner
